import { atom } from "jotai";
import { globalLoaderAtom } from "./globalStateAtoms";
import { urls } from "../constants";
import { GetRequest } from "../api";
import { parseDate } from "../helper";
import { lrSearchColumns } from "../../../helper/constantHelper";

export const ticketCountAtom = atom(0)
export const lrSearchModeAtom = atom(1)
export const selectLrAtom = atom('')
export const showHeaderAtom = atom(true)
export const searchLrDataAtom = atom([])
export const stickerFromAtom = atom(1)
export const stickerToAtom = atom(1)
export const stickerRangeAtom = atom(1)
export const getsearchLrDataAtom = atom(null, async (get, set, data,UseToPayAsCOD,filterOwnLR) => {
  try {
    set(globalLoaderAtom, true);
    const res = await GetRequest(urls.getCargoCommonLRData, data);
    set(globalLoaderAtom, false);
    if (res.status) {
      const list = res?.Data?.Table || [];
      let updatedList = [...list];
      if(filterOwnLR){
        updatedList = updatedList.filter(item => [item.DestinationBranchID,item.BookingBranchID].includes(data.intBranchID));
      }
      if (UseToPayAsCOD === 1) {
        updatedList = updatedList.map((item) => {
          let newPaymentType = item.PaymentType;
          if (item.PaymentType === "To-Pay") newPaymentType = "COD";
          if (item.PaymentType === "To-Pay(Manual)") newPaymentType = "COD (MANUAL)";
          if (item.PaymentType === "ToPayDDDV") newPaymentType = "CODDDDV";
          return { ...item, PaymentType: newPaymentType };
        });
      }
      const matching = [];
      const others = [];
      updatedList.forEach((item) => {
        if (item.BookingBranchID === data.intBranchID) matching.push(item);
        else others.push(item);
      });
      matching.sort((a, b) => parseDate(b.BookingDateTime) - parseDate(a.BookingDateTime));
      others.sort((a, b) => parseDate(b.BookingDateTime) - parseDate(a.BookingDateTime));
      set(searchLrDataAtom, [...matching, ...others]);
    }
  } catch (error) {
    console.error(error);
    set(searchLrDataAtom, []);
  }
})

const STORAGE_KEY = 'lrSearchColumns';
const getInitialValueLRSearchColumns = () => {
  try {
    const local = localStorage.getItem(STORAGE_KEY);
    return local ? JSON.parse(local) : lrSearchColumns;
  } catch {
    return lrSearchColumns;
  }
};
export const lrSearchColumnsStateAtom = atom(getInitialValueLRSearchColumns());
export const showManageColumnAtom = atom(false)
export const lrSearchColumnsAtom = atom(
  (get) => get(lrSearchColumnsStateAtom),
  (get, set, newVal) => {
    set(lrSearchColumnsStateAtom, newVal);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newVal));
  }
);